import { render, staticRenderFns } from "./PropertyTransactionListTable.vue?vue&type=template&id=99086980"
import script from "./PropertyTransactionListTable.vue?vue&type=script&lang=js"
export * from "./PropertyTransactionListTable.vue?vue&type=script&lang=js"
import style0 from "./PropertyTransactionListTable.vue?vue&type=style&index=0&id=99086980&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports